import Literal from "./Literal.js";
/**
 * An alias for `Literal(undefined)`.
 */
const Undefined = Literal(undefined);
export default Undefined;
